module.exports = __webpack_public_path__ + "media/images/category/feature/coj_f/coj_f-5-4d30878e82912474a353a97ee23464bc.jpg";